import React from 'react';
import Icon from './Icon';
import Button from './Button';
import Modal from './Modal';
import './ui.css';

const ErrorModal = ({ open, onClose, title = 'Erro', message, buttonLabel = 'OK' }) => (
  <Modal
    open={open}
    onClose={onClose}
    footer={<Button variant="primary" block onClick={onClose}>{buttonLabel}</Button>}
  >
    <div className="pn-modal__body--center">
      <div className="pn-modal__icon pn-modal__icon--error">
        <Icon name="error" size={50} />
      </div>
      <h2 className="pn-modal__heading">{title}</h2>
      {message ? <p className="pn-modal__subtitle">{message}</p> : null}
    </div>
  </Modal>
);

export default ErrorModal;
